import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin: 0 0 1.5rem;
`;

export const FormRow = (props) => <Container {...props} />;
